import React from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { pageActions, getPages } from "../pageApi"

class WithPages extends React.Component {
    render() {
        const pagesData = this.props.pages
        if (!pagesData) return this.props.loading ? this.props.loading : ""
        const pages = Object.values(pagesData)
        return this.props.children({
            pages,
            onChange: this.props.pageActions.update,
            createPage: this.props.pageActions.create,
        })
    }

    constructor(props) {
        super(props)
        props.pageActions.fetch()
    }
}

WithPages.propTypes = {}

function mapStateToProps(state) {
    return {
        pages: getPages(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        pageActions: bindActionCreators(pageActions, dispatch),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WithPages)



// WEBPACK FOOTER //
// ./src/data/wrappers/WithPages.js